export function normalizeCandidateLog(item) {
    if (item.detalhes || typeof item.acao !== 'string') return item;
    const start = item.acao.indexOf('{');
    if (start < 0) return item;
    try {
        const details = JSON.parse(item.acao.slice(start));
        if (!details || typeof details !== 'object' || Array.isArray(details)) return item;
        return {
            ...item,
            acao: item.acao.slice(0, start).replace(/[\s.:]+$/, ''),
            mensagem: typeof details.mensagem === 'string' ? details.mensagem : item.mensagem,
            detalhes: details,
        };
    } catch (_) {
        return item;
    }
}
